import { openModal } from "./modal"


const CLASSES = {
  FIXED: 'is-fixed',
  SHOW: 'is-show'
}

const DEFAULT_FIXED_POINT = 150

const useHeader = () => {
  const { FIXED, SHOW } = CLASSES

  // header scroll fixed
  const win = $(window)
  const main = $('main')
  const header = $('#header')

  const fixedPoint = main.length ? main.offset().top : DEFAULT_FIXED_POINT
  const showPoint = fixedPoint + 10

  win.on('scroll', () => {
    const st = win.scrollTop()

    if (st > fixedPoint) {
      header.addClass(FIXED)
    }
    else {
      header.removeClass(FIXED)
    }

    if (st > showPoint) {
      header.addClass(SHOW)
    }
    else {
      header.removeClass(SHOW)
    }
  })


  // 計算 menu head 高度
  const menu = $('#menu')
  const menuBtn = $('#menu-btn')

  const calcMenuHeight = () => {
    const menuHeadHeight = menu.find('.menu-head').outerHeight(true) + menu.find('.menu-member').outerHeight(true)
    menu.css({ '--menu-head-height': `${menuHeadHeight / 16}rem` })
  }

  menuBtn.on('click', () => openModal('#menu', calcMenuHeight))


  // menu search clear
  menu.find('#menu-search-clear').on('click', () => {
    menu.find('#menu-search-input').val('')
  })

  // menu search 打開後 focus
  menu.find('#menu-search-btn').on('click', () => {
    openModal('#menu-search')
    menu.find('#menu-search-input').focus()
  })


  // menu item-list 打開&關閉
  menu.find('.menu-list_item > span').on('click', function () {
    const self = $(this)
    const list = self.siblings('.item-list')
    const parent = self.closest('.menu-list_item')

    if (parent.hasClass('is-active')) {
      list.slideUp()
      parent.removeClass('is-active')
    }
    else {
      list.slideDown()
      parent.addClass('is-active').siblings().removeClass('is-active').find('.item-list').slideUp()
    }
  })
}


export { useHeader }